import React from "react";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";

import "./footer.css";

const footerQuickLinks = [
  {
    display: "Негізгі Бет",
    url: "/",
  },
  {
    display: "Емтихан Беті",
    url: "#",
  },

  {
    display: "Курстар Беті",
    url: "#",
  },

  {
    display: "Тапсырмалар Беті",
    url: "/testing",
  },
  {
    display: "Теория Беті",
    url: "/teories",
  },
];

const footerInfoLinks = [
  {
    display: "Құпиялылық саясаты",
    url: "#",
  },
  {
    display: "Мүшелік",
    url: "#",
  },

  {
    display: "Қарым-қатынас",
    url: "#",
  },

  {
    display: "Қызметтер",
    url: "#",
  },
];

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg="3" md="6" className="mb-4">
            <h2 className=" d-flex align-items-center gap-1">
              <i class="ri-pantone-line"></i> Diplome Work
            </h2>

            <div className="follows">
              <p className="mb-0">Мені әлеуметтік желіде бақылаңыз</p>
              <span>
                {" "}
                <a href="facebook.com">
                  <i class="ri-facebook-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="facebook.com">
                  <i class="ri-instagram-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="facebook.com">
                  <i class="ri-linkedin-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="facebook.com">
                  <i class="ri-twitter-line"></i>
                </a>
              </span>
            </div>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <h6 className="fw-bold">Зерттеу</h6>
            <ListGroup className="link__list">
              {footerQuickLinks.map((item, index) => (
                <ListGroupItem key={index} className="border-0 ps-0 link__item">
                  {" "}
                  <a href={item.url}>{item.display}</a>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <h6 className="fw-bold">Ақпарат</h6>
            <ListGroup className="link__list">
              {footerInfoLinks.map((item, index) => (
                <ListGroupItem key={index} className="border-0 ps-0 link__item">
                  {" "}
                  <a href={item.url}>{item.display}</a>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="3" md="6">
            <h6 className="fw-bold">Менің ақпаратым</h6>
            <p>Мекен-жайы: Евразийский национальный университет</p>
            <p>Телефон: +7765219136 </p>
            <p>Email: example@gmail.com</p>
          </Col>
        </Row>

        <div className="last-div">
          <p><b>Copyright © <b>Begaiym</b> All rights reserved</b></p>
        </div>

      </Container>
    </footer>
  );
};

export default Footer;
